import tippy from 'tippy.js';

const html = `<div class="drawer-nav__categories desktop">${$('.drawer-nav__categories').html()}</div>`;

const parentNode = tippy(document.querySelector('button.category-drawer__button'));

// need refactor
parentNode.setProps({
  animation: 'scale-subtle',
  content: html,
  allowHTML: true,
  placement: 'bottom-start',
  interactive: true,
  animateFill: false,
  boundary: 'viewport',
  hideOnClick: 'toggle',
  appendTo: document.body,
  interactiveBorder: 20,
  moveTransition: 'transform 0.2s ease-out',
  offset: [-30, 0],
  onShow() {
    setTimeout(() => {
      tippy(document.querySelectorAll('.header-nav__has-child'), {
        animation: 'scale-subtle',
        moveTransition: 'transform 0.2s ease-out',
        interactive: true,
        hideOnClick: 'toggle',
        content(reference) {
          return `<ul class="header-nav__list drawer-nav__category" style="display:block;background-color:white;padding:5px 20px;border-radius:7px;" role="menubar">${$(reference).next().html()}</ul>`;
        },
        placement: 'right-start',
        appendTo: 'parent',
        allowHTML: true,
        offset: [-5, 20],
      });
    }, 10);
  },
});
